import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isSignInWithEmailLink, signInWithEmailLink} from "firebase/auth";
import { auth, db } from "../firebaseconfig";
import { doc, getDoc, setDoc } from "firebase/firestore";

export function FinishSignUp() {

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        // 1) Check if the URL contains the sign-in link
        if (isSignInWithEmailLink(auth, window.location.href)) {

            let email = window.localStorage.getItem("emailForSignIn");

            // If the email is not in local storage, prompt the user for it
            if (!email) {
                email = window.prompt("Please provide your email:");
            }

            // Complete sign in with the standard Firebase method
            signInWithEmailLink(auth, email, window.location.href)
            .then(async(result) => {
        
                const docRef = doc(db, "users", result.user.uid)

                // If the user does not exist in the database, create a new user document
                if (!(await getDoc(docRef)).exists()) {
                    await setDoc(docRef, {
                        email: result.user.email,
                        vote: null,
                        categorySelected: false,
                        category: null
                    })
                }

                navigate("/vote-fans", { replace: true })

            })
            .catch((error) => {
                navigate("/", { state: {from: location.pathname, message: "Hiba történt a bejelentkezés során, vagy a link nem megfelelő!"}, replace: true});
            });
        } else {
            navigate("/", { state: {from: location.pathname, message: "Hiba történt a bejelentkezés során, vagy a link nem megfelelő!"}, replace: true})
        }

    }, [navigate, location]);

    return <div>Bejelentkezés...</div>;

}
